'use client';

import type { PropsWithChildren } from 'react';
import { useRecoElement } from '../../hooks/useRecoElement';
import { useProductsRecoTracking, type TrackingProps } from './useProductsRecoTracking';

type Props = TrackingProps & PropsWithChildren;

export const ProductsRecoTracking = ({ children, ...trackingProps }: Props) => {
  const { recoEl, isInView } = useRecoElement();

  const condition = isInView && trackingProps.trackingCondition;

  useProductsRecoTracking({ ...trackingProps, trackingCondition: condition });

  return <div ref={recoEl}>{children}</div>;
};
